import {isDisconnectRejection} from "../ws/WsClient";
import {AppNotificationCreateAttributes} from "../context/NotificationContext";

type Notifier = {
  createNotification: (attributes: AppNotificationCreateAttributes) => string
  hideNotification: (id: string) => void
}

// RISKS.md/P2.15: raise a websocket-failure toast through this, not `createNotification`. A send
// that lost its socket is not reported at all (`isDisconnectRejection` says why), and a fixed id is
// retracted first, because de-duping is first-wins and would drop the newer message (RISKS.md/P2.44).
//
// ⚠ Give `actions` only to a `persistent` toast: a retry inside a `ttl` toast vanishes while the
// failure it offers to undo is still current. Where the control that failed is still on screen, it
// IS the retry, so those pass a `ttl` and no action.
export const notifyWsFailure = (
  notifier: Notifier,
  e: unknown,
  notification: AppNotificationCreateAttributes & { id: string },
) => {
  if (isDisconnectRejection(e)) return
  notifier.hideNotification(notification.id)
  notifier.createNotification(notification)
}
